import React, { useState, useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  Input,
  FormControl,
  FormLabel,
  Textarea,
} from "@chakra-ui/react";
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Common components
import CommonCheckbox from "../../../components/common/checkbox/checkbox";
// Maintenance components
import MaintenanceForm from "../../../components/maintenance/form/form";
// Components
import Upload from "../../../components/upload/upload";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as podcastsGroupsActions from "../../../redux/actions/podcastsGroups";
import * as filesActions from "../../../redux/actions/files";
// Styles
import "./form.css";

const PodcastsGroupsForm = ({ isNew }) => {
  const dispatch = useDispatch();
  const childRef = useRef();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    "enabled": true,
  });
  const [isDirty, setIsDirty] = useState(false);
  const [isDirtyFiles, setIsDirtyFiles] = useState(false);
  const [files_1, setFiles_1] = useState([]);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);

  // Set constants
  const page = "podcasts_groups";
  const primaryName = !isNew && !!form[`title`] ? form[`title`] : ``;
  const itemNameSingular = "Grup de Podcast";

  // Get id from url
  let id = null;
  const { id: paramId } = useParams();
  if (!isNew) {
    id = parseInt(paramId);
  }

  useEffect(() => {
    if (!!currentPage) return;

    // Set active page
    dispatch(mainActions.setCurrentPage(page));

    // Set initial breadscrum
    if (isNew) {
      const pathKey = 'new';
      const path = `${page}/${pathKey}`;
      dispatch(mainActions.setBreadscrum(page, [{ path, pathKey: 'new-m', itemNameSingular, }]));
    } else {
      const pathKey = 'edit';
      const path = `${page}/${pathKey}/${id}`;
      dispatch(mainActions.setBreadscrum(page, [{ path, pathKey, primaryValue: id, primaryName, itemNameSingular, }]));
    }
  }, []);

  const handleChange = (evt) => {
    if (childRef.current) {
      childRef.current.handleChange(evt);
    }
  };

  const renderForm = () => {
    return (
      <div className="podcasts-groups-form-wrapper">
        <div className="podcasts-groups-form-firstcolumn-wrapper">
          {renderMainCard()}
        </div>
        <div className="maintenance-form-card">
          {renderUploadCard_1()}
        </div>
      </div>
    );
  };

  const renderMainCard = () => {
    let title;
    if (isNew) {
      title = "Nou Grup de Podcast";
    } else {
      title = `Grup de Podcast${!!form[`id`] ? ` amb Id: ${form[`id`]}` : ''}`;
    }

    return (
      <div className="podcasts-groups-form-maincard">
        <div className="title maintenance-form-title">
          {title}
        </div>  
        {/* IMPORTANT !!! Els checkboxes no poden estar en el mateix FormControl En producció no funciona!! */}
        <CommonCheckbox
          isChecked={!!form['enabled']}
          onChange={(e) => {
            setForm({
              ...form,
              "enabled": e.target.checked,
            });     
            setIsDirty(true);         
          }}
        >
          Habilitat
        </CommonCheckbox>            
        <FormControl isRequired mt={4}>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Títol
          </FormLabel>
          <Input
            className="maintenance-form-field"
            placeholder="Títol"
            name="title"
            data-type={`string`}
            onChange={handleChange}
            value={form[`title`] ? form[`title`] : ``}
          />
        </FormControl>           
        <FormControl mt={4}>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Sub-títol
          </FormLabel>
          <Input
            className="maintenance-form-field"
            placeholder="Sub-títol"
            name="subtitle"
            data-type={`string`}
            onChange={handleChange}
            value={form[`subtitle`] ? form[`subtitle`] : ``}
          />
        </FormControl>     
        <FormControl mt={4}>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Programació
          </FormLabel>
          <Input
            className="maintenance-form-field"
            placeholder="Programació"
            name="programming"
            data-type={`string`}
            onChange={handleChange}
            value={form[`programming`] ? form[`programming`] : ``}
          />
        </FormControl>
        <FormControl mt={4}>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Descripció
          </FormLabel>
          <Textarea
            className="maintenance-form-field"
            placeholder="Descripció"
            name="description"
            data-type={`string`}
            onChange={handleChange}
            value={form[`description`] ? form[`description`] : ``}
            minHeight="200px"
          />
        </FormControl>
        <FormControl mt={4}>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            URL web
          </FormLabel>
          <Input
            className="maintenance-form-field"
            placeholder="https://"
            name="url_web"
            data-type={`string`}
            type="url"
            onChange={handleChange}
            value={form[`url_web`] ? form[`url_web`] : ``}
            maxLength={1024}
          />       
        </FormControl> 
        <FormControl w="200px" mt={4} >
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Prioritat
          </FormLabel>
          <Input
              className="maintenance-form-field"     
              placeholder="Prioritat"
              name={`priority`}
              data-type={`integer`}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (!isNaN(inputValue)) {
                  handleChange(e);
                }
              }}
              value={form[`priority`] ? form[`priority`] : ``}
              inputMode="numeric"
              w="120px"
              textAlign="left"
              type="number"
              min={1}
          />
        </FormControl>           
      </div>   
    );
  };

  const renderUploadCard_1 = () => {
    return (
      <div className="podcasts-groups-form-upload-card">
        <FormControl>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Imatge
          </FormLabel>    
          {/* <Input
            className="maintenance-form-field"
            placeholder="https://"
            name="url_image_1"
            data-type={`string`}
            type="url"
            onChange={handleChange}
            value={form[`url_image_1`] ? form[`url_image_1`] : ``}
          /> */}
        </FormControl>            
        <Upload 
          type={"podcasts_group"}
          id={id}
          id2={"1"}
          style={{ marginTop: "10px"}}
          onChange={(files) => {
            setFiles_1(files);        
          }}      
          onNewFile={(newFiles) => {
            setIsDirty(true);
            setIsDirtyFiles(true);
          }}           
          onDeleteFile={(file) => {
            setIsDirty(true);
            setIsDirtyFiles(true);
          }}           
          onUpdateFile={(file) => {
            setIsDirty(true);
            setIsDirtyFiles(true);
          }} 
        />
      </div>
    );
  };

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="podcasts-groups-form-content">
        <MaintenanceForm 
          primaryKey={"id"}
          primaryValue={id}
          primaryName={primaryName}
          config={{
            submitFields: [ 
              `title`,
              `subtitle`,
              `programming`,
              `priority`,
              `description`,
              `url_image_1`,
              `url_web`,
              `enabled`,
            ],
          }}
          menuConfig={{}}
          itemNameSingular={itemNameSingular}
          itemIsMale={true}
          actions={podcastsGroupsActions} 
          setIsLoading={setIsLoading}
          renderForm={renderForm}
          form={form}
          setForm={setForm}
          isDirty={isDirty}
          setIsDirty={setIsDirty}
          ref={childRef}
          isNew={isNew}
          page={"podcasts_groups"}
          executeAfterSaving={async (theId) => {
            return new Promise((resolve) => {
              if (!isDirtyFiles) {
                resolve({ success: true });
              }
              dispatch(filesActions.setFiles("podcasts_group", theId, "1", files_1)).then(
                () => {
                  resolve({ success: true });
                },
                (err) => resolve({ success: false, msg: err })
              );
            });
          }}
        />
      </div>
    </MainLayout>
  );
};

export default PodcastsGroupsForm;
